import { createStore } from 'solid-js/store';
import type { Slot, SheetState } from '../types';

const initialSlots: Slot[] = Array.from({ length: 15 }, (_, id) => ({
  id,
  image: null,
  fitTarget: 'bleed' as const,
}));

export const [sheet, setSheet] = createStore<SheetState>({ slots: initialSlots });
